<template>
  <v-img src="/4.webp" height="600" cover>
    <v-container>
        <FormularioForm class="d-sm-none bg-white px-4 rounded-lg"/>
        <v-row class="d-none d-sm-flex justify-center align-end">
          <v-col cols="6" class="bg-white  px-4"><FormularioForm /></v-col>
          <v-col cols="6" >
            <NuxtImg src="/formulario.webp"   format="webp" loading="lazy" alt="formulario imagem"  height="500" aria-label="formulario imagem"/>
          </v-col>
        </v-row>
      </v-container>
  </v-img>
</template>
  
     